import styled from 'styled-components';
import Link from 'ggApp/shared/common/Button/Link';

export const Wrap = styled.div`
    display: ${({ isHidden }) => (isHidden ? 'none' : 'flex')};
    align-items: flex-start;
    flex-direction: column;
    position: relative;
    background: ${({ theme }) => theme.colors["Level 1"]};
    border-radius: 0px 8px 8px 0px;
`;

export const Background = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    border-radius: 0px 8px 8px 0px;
`;

export const ViewAllLink = styled(Link)`
    margin: ${({ theme }) => `${theme.spacers.M} 0`};
    &:hover,
    &:focus,
    &:active {
        background: unset;
        color: unset;
        box-shadow: unset;
        border: unset;
    }
`;